import { REACT_APP_API_BULK_RULE_CREATION } from 'config';

const dashboard = 'dashboard';
const upload = 'upload';
const organization = 'organization';
const fileUpload = 'rule_file_upload';
const userEvalPermissionDetails = 'user_eval_permission_details';
const frequency = 'frequency';
const workflow = 'workflow';
const program = 'program_configuration';
const heirarchy = 'iprogram-hierarchy-master';
const updateUserLanguage = 'update_user_language';
const getUnifiedSourceColumnList = 'get_unified_source_column_list';
const roles = 'roles';
const rolesList = 'roles-list';
const qualifier = 'payment-party-configuration';
const programConfigDetails = 'program_config_details';
const rulesPlan = 'rule_plan';
const ruleGroup = 'rule_group';
const rules = 'rules';
const dataSourceColumnList = 'data_source_column_list';
const getOutputVariableList = 'get_output_variable_list';
const deleteRulesAfterUniChange = 'delete_rules_of_rule_plan_id';
const workflowapproverDetails = 'get_workflow_approver_details';
const userRoles = 'get_user_roles_program_details';
const getReportingPayoutList = 'get_reporting_payout_variable_details';
const updateUserRoleProgramDetails = 'update_user_role_program_details';
const incentiveProgram = 'incentive_program';
const copyRulePlan = 'copy_rule_plan';
const copyRule = 'copy_rule';
const unifiedColumnDetails = 'unified_column_details';
const targetSetting = 'target_setting';
const getProgramRoles = 'get_program_roles';
const getQueryJson = 'get_payout_formula_json';
const userDetails = 'user_details';
const masterSourceConnection = 'master_data_source_connections';
const masterSourceColumn = 'master_data_source_column';
const targetHierarchy = 'target_hierarchy';
const targetConfiguration = 'target_configuration';
const holidayDetails = 'holiday_details';
const specificHoliday = 'specific_holiday';
const getDmnXmlString = 'get_dmn_xml_string';
const targetFrequency = 'target_frequency';
const finalPayoutRules = 'final-payout-rules';
const attribute = 'user_attr_master_mapping';
const targetValuesFromFile = 'get_target_values_from_master_file';
const rulesPlanDraft = 'rule_plan_draft';
const ruleGroupDraft = 'rule_group_draft';
const rulePlanDraftList = 'rule_plan_draft';
const rulesDraft = 'rules_draft';
const sendRulePlanForApproval = 'send_rule_plan_for_approval';
const templateDetails = 'template_details';
const getCouponList = 'get_coupon_list';
const contestDraft = 'contest-draft';
const sendContestForApproval = 'send-contest-for-approval';
const getUserAttributes = 'get_user_attributes';
const masterSources = 'master-sources';
const masterSourcesColumns = 'master-sources-columns';
const getActiveUnifieds = 'get-active-unifieds';
const getProgramQueries = 'program-queries';
const programQueryList = 'program-queries';
const programQueryDetail = 'program-query';
const programQueryUpdate = 'update-program-query';
const getMasterColumnListUsedInUnified =
  'get_master_column_list_used_in_unified';
const reviewSourceList = 'review-source-list';
const bulkRule = 'bulk_rules';
const bulkRuleErrorDownload = `${REACT_APP_API_BULK_RULE_CREATION}/bulk_rules`;
const bulkRuleCreationTempalte = `${REACT_APP_API_BULK_RULE_CREATION}/download_bulk_rule_creation_template`;
const gridApprovalWorkflow = 'grid_approval_workflow';
const downloadRules = 'download_rules';
const downloadBulkRule = 'download_rules';
const sendGridForApproval = 'send_grid_for_approval';
const getProgrambasedUnifiedSource = 'get_program_based_unified_sources';
const hookEvent = 'system_event';
const hookRegistration = 'hook_registration';
const systemEventParam = 'system_event_param';
const hookInstance = 'hook_instance';
const programConfigVariable = 'program_config_variable';
const screens = 'screens';
const screenDetails = 'screen-details';
const screenActions = 'screens/actions';
const screenBuildConfig = 'screen-build-config';
const subModules = 'sub-modules';

const apiEndpoint = {
  dashboard,
  upload,
  organization,
  fileUpload,
  userEvalPermissionDetails,
  frequency,
  workflow,
  program,
  heirarchy,
  updateUserLanguage,
  getUnifiedSourceColumnList,
  roles,
  rolesList,
  qualifier,
  programConfigDetails,
  rulesPlan,
  ruleGroup,
  rules,
  dataSourceColumnList,
  getOutputVariableList,
  deleteRulesAfterUniChange,
  workflowapproverDetails,
  userRoles,
  getReportingPayoutList,
  updateUserRoleProgramDetails,
  incentiveProgram,
  copyRulePlan,
  copyRule,
  unifiedColumnDetails,
  targetConfiguration,
  targetSetting,
  getProgramRoles,
  getQueryJson,
  userDetails,
  masterSourceConnection,
  masterSourceColumn,
  targetHierarchy,
  holidayDetails,
  specificHoliday,
  getDmnXmlString,
  targetFrequency,
  finalPayoutRules,
  attribute,
  targetValuesFromFile,
  rulesPlanDraft,
  ruleGroupDraft,
  rulePlanDraftList,
  rulesDraft,
  sendRulePlanForApproval,
  templateDetails,
  getCouponList,
  contestDraft,
  sendContestForApproval,
  getUserAttributes,
  masterSources,
  masterSourcesColumns,
  getActiveUnifieds,
  getProgramQueries,
  programQueryList,
  programQueryDetail,
  programQueryUpdate,
  getMasterColumnListUsedInUnified,
  reviewSourceList,
  bulkRule,
  bulkRuleCreationTempalte,
  bulkRuleErrorDownload,
  gridApprovalWorkflow,
  downloadRules,
  downloadBulkRule,
  sendGridForApproval,
  getProgrambasedUnifiedSource,
  hookEvent,
  hookRegistration,
  systemEventParam,
  hookInstance,
  programConfigVariable,
  screens,
  screenDetails,
  screenActions,
  screenBuildConfig,
  subModules,
};

export default apiEndpoint;
